import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { findBranch } from '../../api/branch';

const style = {
    container: {
        textAlign: "left",
        marginLeft: 20,
        backgroundColor: '#d8dbdd'
    },
    icon: {
        color: 'blue',
        fontSize: '1.5rem',
        textAlign: 'center',
        alignItems: 'center',
        marginTop: 5,
        marginLeft: 5,
    },
    children: {
        border: '0.5px solid rgba(0,255,255,0.8)',
        padding: '4px'
    },
    label: {
        fontSize: '1.4rem',
        width: '120px',
        margin: 0,
        padding: 0,
        fontWeight: '500',
        textAlign: 'left'
    },
    textarea: {
        width: '520px',
        fontSize: '1.4rem',
    },
    text: {
        fontSize: '1.4rem'
    }
};

function CompanyEditDetails(props) {
    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);

    const { role } = auth.user;
    const isDisabled = (role !== 2 && role !== 3 && role !== 6);
    const [listBranch, setListBranch] = useState([])
    const [countChange, setCountChange] = useState(0);
    const [dataState, setDataState] = useState({
        _id: "",
        // branchId: 0,
        name: "",
        address: "",
        branch: "",
        branchID: 0,
        company_id: 0,
        email:"",
        contract: false,
        travel: false,
        represent_name: "",
        special: "",
        special_rate: 0,
        special_notify: false,
        tax: "",
        tel: "",
        note: "",
    });

    useEffect(() => {
        if (props.data) {
            // load branch data
            if (typeof props.data === 'object') setDataState(previous => ({...previous, ...props.data}))
        }

        if(role === 6) {
            // load list branch 
            const loadBranch = async () => {
                const dataResult = await findBranch("listBranchArea", {value: null },token);
                setListBranch(dataResult.data.branch);
            }

            loadBranch();
        }

    }, [props.data, role, token]);

    function onChangeDate(value, target, option) {
        const newData = { ...dataState };

        newData[target] = value;
        setDataState(newData);
        setCountChange(countChange + 1);

    }

    function renderListBranch() {
        let result = []
        if(listBranch.length > 0) {
            result.push(<option
                value={0}
                disabled = {isDisabled}
                style={{ fontSize: '1.3rem', width:"130px" }}
                >  {"Select branch"}</option>)

            listBranch.forEach(item => {
                result.push(<option
                        value={item.branchID}
                        disabled = {isDisabled}
                        style={{ fontSize: '1.3rem', width:"130px" }}
                        >  {item.name}</option>)
            })
        }

        return result;
    }

    return (
        <div >
            <div className="d-flex ">
                <div style={{ width: '100%' }} >

                    {role === 6 && <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Editing as branch?</label>
                        <select id="cars" style={{width:"80%"}} onChange={e => onChangeDate(e.target.value, "branchID", undefined)}>
                             {renderListBranch()}
                        </select>
                    </div>}

                    {/* <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Contract ?</label>
                        <div class="input-group-prepend " style={{ width: '80%' }}>
                            <div class="input-group-text">
                                <input
                                    disabled = {isDisabled}
                                    type="radio"
                                    id="yes"
                                    checked={dataState.contract}
                                    onChange={() => onChangeDate(true, "contract", "")}
                                />
                                <label style={style.text} for="yes">Yes</label>
                            </div>

                            <div class="input-group-text">
                                <input
                                    disabled = {isDisabled}
                                    type="radio"
                                    id="no"
                                    checked={!dataState.contract}
                                    onChange={() => onChangeDate(false, "contract", "")}
                                />
                                <label style={style.text} for="no">No</label>
                            </div>
                        </div>
                    </div> */}

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Name(*)</label>
                        <input
                            disabled = {isDisabled}
                            type="text"
                            style={{ width: '80%' }}
                            value={dataState.name}
                            onChange={e => onChangeDate(e.target.value, "name", "")}
                        />
                    </div>

                     <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Email(*)</label>
                        <input
                            disabled = {isDisabled}
                            type="text"
                            style={{ width: '80%' }}
                            value={dataState.email}
                            onChange={e => onChangeDate(e.target.value, "email", "")}
                        />
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Contract ?</label>
                        <div class="input-group-prepend " style={{ width: '80%' }}>
                            <div class="input-group-text">
                                <input
                                    disabled = {isDisabled}
                                    type="radio"
                                    id="yes"
                                    checked={dataState.contract}
                                    onChange={() => onChangeDate(true, "contract", "")}
                                />
                                <label style={style.text} for="yes">Yes</label>
                            </div>

                            <div class="input-group-text">
                                <input
                                    disabled = {isDisabled}
                                    type="radio"
                                    id="no"
                                    checked={!dataState.contract}
                                    onChange={() => onChangeDate(false, "contract", "")}
                                />
                                <label style={style.text} for="no">No</label>
                            </div>
                        </div>
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Travel ?</label>
                        <div class="input-group-prepend " style={{ width: '80%' }}>
                            <div class="input-group-text">
                                <input
                                    disabled = {isDisabled}
                                    type="radio"
                                    id="yes"
                                    checked={dataState.travel}
                                    onChange={() => onChangeDate(true, "travel", "")}
                                />
                                <label style={style.text} for="yes">Yes</label>
                            </div>

                            <div class="input-group-text">
                                <input
                                    disabled = {isDisabled}
                                    type="radio"
                                    id="no"
                                    checked={!dataState.travel}
                                    onChange={() => onChangeDate(false, "travel", "")}
                                />
                                <label style={style.text} for="no">No</label>
                            </div>
                        </div>
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Address</label>
                        <textarea 
                            disabled = {isDisabled}
                            style={{ width: '80%', height: '60px' }}
                            onChange={e => onChangeDate(e.target.value, "address", "")}
                            value={dataState.address}></textarea>
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Represent name</label>
                        <input
                            disabled = {isDisabled}
                            type="text"
                            style={{ width: '80%' }}
                            value={dataState.represent_name}
                            onChange={e => onChangeDate(e.target.value, "represent_name", "")}
                        />
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Tax</label>
                        <input
                            disabled = {isDisabled}
                            type="text" style={{ width: '80%' }}
                            value={dataState.tax}
                            onChange={e => onChangeDate(e.target.value, "tax", "")}
                        />
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Phone</label>
                        <input
                            disabled = {isDisabled}
                            type="text" style={{ width: '80%' }}
                            value={dataState.tel}
                            onChange={e => onChangeDate(e.target.value, "tel", "")}
                        />
                    </div>

                    <div style={style.children} className="d-flex justify-content-around">
                        <label style={style.label}>Special</label>
                        <textarea 
                            disabled = {isDisabled}
                            style={{ width: '80%', height: '60px' }}
                            onChange={e => onChangeDate(e.target.value, "special", "")}
                            value={dataState.special}></textarea>
                    </div>

                    {
                    // Waiting Update
                        props.data && <div style={style.children} className="d-flex justify-content-around">
                        <label style={{...style.label, color:"red"}}>Reason for the change (*)</label>
                        <textarea 
                            disabled = {isDisabled}
                            style={{ width: '80%', height: '60px',border: '1px solid red' }}
                            onChange={e => onChangeDate(e.target.value, "note", "")}
                            value={dataState.note}></textarea>
                    </div>
                    }
                    
                </div>
            </div>
            {
                !isDisabled && <div class="mt-1">
                {countChange > 0 && <button className="btn btn-primary"
                   // disabled={props.data === undefined ? false : ((dataState.note !== "") ? false : true)}
                    onClick={() => props.onSave(dataState, !props.data ?
                        "create_new" : "change", 
                        !props.data ? "" : props.data.index)}>
                    {props.data === undefined ? "Create New" : "Save Change"}
                </button>}

                <button className={props.data === undefined ? "op-hidden" : "btn btn-danger ml-2"}
                    onClick={() => props.onDelete(dataState._id)}>
                    {props.data === undefined ? "" : "Delete"}
                </button>
                <button className="btn btn-danger ml-2"
                    onClick={() => props.onClose()}>Cancel</button>
                </div>
            }

        </div >
    )
}

export default CompanyEditDetails;
